"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default(base) {
  let modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return [base].concat(modifiers.filter(str => str)).join(' ' + base + '--');
}
